import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";

/** Paginação CENTRALIZADA padrão das listagens CRUD — números de página estilo SaaS. */
export default function Pagination({ page, totalPages, total, onPage, unitLabel = "registros" }) {
  if (!totalPages || totalPages <= 1) return null;

  // Monta a lista de páginas com reticências (janela de 7).
  const pages = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else if (page <= 4) {
    pages.push(1, 2, 3, 4, 5, "…", totalPages);
  } else if (page >= totalPages - 3) {
    pages.push(1, "…", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
  } else {
    pages.push(1, "…", page - 1, page, page + 1, "…", totalPages);
  }

  const nav =
    "h-9 w-9 rounded-lg inline-flex items-center justify-center text-neutral-600 hover:bg-neutral-100 transition-colors disabled:opacity-40 disabled:cursor-not-allowed";

  return (
    <div className="flex flex-col items-center gap-2 pt-1" data-testid="pagination">
      {/* flex-wrap + max-w-full: no celular (360px) os botões quebram linha em vez de passar da
          tela (rolagem horizontal e "Primeira página" fora do alcance). No desktop nada muda. */}
      <div className="flex flex-wrap items-center justify-center max-w-full gap-1 glass rounded-2xl px-1.5 py-1">
        <button data-testid="page-first" disabled={page <= 1} onClick={() => onPage(1)} className={nav} title="Primeira página"><ChevronsLeft size={16} /></button>
        <button data-testid="page-prev" disabled={page <= 1} onClick={() => onPage(page - 1)} className={nav} title="Anterior"><ChevronLeft size={16} /></button>

        {pages.map((p, i) =>
          p === "…" ? (
            <span key={`e${i}`} className="px-1.5 text-neutral-400 select-none">…</span>
          ) : (
            <button key={p} data-testid={`page-${p}`} onClick={() => onPage(p)} aria-current={p === page ? "page" : undefined}
                    className={`h-9 min-w-[36px] px-2 rounded-lg text-[13px] font-semibold transition-colors ${p === page ? "text-white shadow-sm" : "text-neutral-600 hover:bg-neutral-100"}`}
                    style={p === page ? { background: "linear-gradient(135deg,#0A2A73,#1660D6)" } : undefined}>
              {p}
            </button>
          )
        )}

        <button data-testid="page-next" disabled={page >= totalPages} onClick={() => onPage(page + 1)} className={nav} title="Próxima"><ChevronRight size={16} /></button>
        <button data-testid="page-last" disabled={page >= totalPages} onClick={() => onPage(totalPages)} className={nav} title="Última página"><ChevronsRight size={16} /></button>
      </div>

      <div className="text-[11.5px] text-neutral-500">
        Página <b className="text-[color:var(--ink)]">{page}</b> de <b className="text-[color:var(--ink)]">{totalPages}</b>
        {" · "}<b className="text-[color:var(--ink)]">{total}</b> {unitLabel}
      </div>
    </div>
  );
}
